import { render, staticRenderFns } from "./MerchantDashboard.vue?vue&type=template&id=93c39f2a&scoped=true"
import script from "./MerchantDashboard.vue?vue&type=script&lang=js"
export * from "./MerchantDashboard.vue?vue&type=script&lang=js"
import style0 from "./MerchantDashboard.vue?vue&type=style&index=0&id=93c39f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c39f2a",
  null
  
)

export default component.exports